export { DMS_MODULE } from '../constants';
export const CRUMB_LABEL_KEY = 'grdWatchlistApproval';
export const NAME = 'WatchlistApproval';
